import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * 用户状态管理 Store
 * 负责管理软件更新与进度上报
 */
export const useUpdateStore = defineStore('update', () => {
  interface ProgressInfo {
    status: Status
    process?: Process
  }

  type Status = 'undownload' | 'downloading' | 'finished' | 'error'

  interface Process {
    percent: number
    speed: number
    transferred: number
    total: number
  }

  const hasNewVersion = ref(false)
  const updateInfo = ref<null | {
    releaseDate: string
    version: string
    releaseNotes: string
    releaseImg: string
  }>(null)
  const status = ref<Status>('undownload')
  const process = ref<Process | null>(null)

  // 检查更新
  const checkUpdate = async () => {
    let hasUpdate = undefined
    try {
      hasUpdate = await window.electronAPI?.checkUpdate()
    } catch (_error) {
      console.error('check update error')
    }
    if (!hasUpdate) {
      status.value = 'undownload'
    } else {
      // 外部自行决定要不要走下一步下载
    }
    return hasUpdate
  }

  // 下载更新
  const downloadUpdate = () => {
    window.electronAPI?.downloadUpdate()
  }

  // 安装更新
  const installUpdate = () => {
    window.electronAPI?.installUpdate()
  }

  // 检查并下载更新
  const checkAndDownload = async () => {
    registerAvailable()
    status.value = 'downloading'
    const hasUpdate = await checkUpdate()
    if (hasUpdate) {
      registerProcessEvents()
      downloadUpdate()
    }
  }

  // 注册是否有可用更新事件
  const registerAvailable = () => {
    window.electronAPI?.onUpdateAvailable((res) => {
      hasNewVersion.value = res.isUpdateAvailable
      updateInfo.value = res.info
    })
  }

  // 注册下载进度事件
  const registerProcessEvents = () => {
    window.electronAPI?.onUpdateProgress((res: ProgressInfo) => {
      status.value = res.status
      process.value = res.process!
    })
  }
  return {
    status,
    process,
    hasNewVersion,
    updateInfo,
    checkUpdate,
    downloadUpdate,
    installUpdate,
    checkAndDownload,
    registerAvailable,
    registerProcessEvents,
  }
})
